import { render } from "./AccountResetPassword.vue?vue&type=template&id=e5344922&scoped=true"
import script from "./AccountResetPassword.vue?vue&type=script&lang=js"
export * from "./AccountResetPassword.vue?vue&type=script&lang=js"

import "./AccountResetPassword.vue?vue&type=style&index=0&id=e5344922&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5344922"]])

export default __exports__